import { useDispatch, useSelector } from 'react-redux'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Col from 'react-bootstrap/Col'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import PropTypes from 'prop-types'
import Spinner from '../components/Spinner'
import styles from '../styles/Settings.module.scss'
import { updateProfile } from '../store/auth'
import useDarkMode from 'use-dark-mode'
import { v4 } from 'uuid'

const Settings = ({ handleClose, show }) => {
  const darkMode = useDarkMode(false)
  const dispatch = useDispatch()
  const profile = useSelector((state) => state.firebase.profile)

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Settings</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Row>
            <Form.Label column xs={3}>
              Dark Mode
            </Form.Label>
            <Col className={styles.darkModeSlider}>
              <Form.Switch
                id='dark-mode'
                checked={darkMode.value}
                label={
                  <FontAwesomeIcon icon={darkMode.value ? 'moon' : 'sun'} />
                }
                onChange={darkMode.toggle}
              />
            </Col>
          </Form.Row>
        </Form.Group>
        {profile.isLoaded ? (
          <>
            {profile.priceSources?.map((priceSource, i) => (
              <Form.Group key={v4()}>
                <Form.Row>
                  <Form.Label column xs={4}>
                    {`Price Source ${i + 1}`}
                  </Form.Label>
                  <Col>
                    <Form.Control
                      as='select'
                      onChange={(e) => {
                        const priceSources = [
                          ...profile.priceSources.slice(0, i),
                          e.target.value,
                          ...profile.priceSources.slice(i + 1),
                        ]
                        dispatch(updateProfile({ priceSources }))
                      }}
                      value={priceSource}
                    >
                      <option value='cardkingdom'>Card Kingdom</option>
                      <option value='tcgplayer'>TCGplayer</option>
                      <option value='cardhoarder'>Cardhoarder (MTGO)</option>
                      <option value='cardmarket'>Cardmarket (EU)</option>
                    </Form.Control>
                  </Col>
                </Form.Row>
              </Form.Group>
            ))}
            <Form.Row>
              <Form.Label column xs={3}>
                Show Salt?
              </Form.Label>
              <Col>
                <ButtonGroup>
                  {['Never', 'High Salt', 'Always'].map((label, i) => (
                    <Button
                      key={label}
                      onClick={() => dispatch(updateProfile({ saltLevel: i }))}
                      variant={
                        profile.saltLevel === i ? 'primary' : 'secondary'
                      }
                    >
                      {label}
                    </Button>
                  ))}
                </ButtonGroup>
              </Col>
            </Form.Row>
          </>
        ) : (
          <Spinner />
        )}
      </Modal.Body>
    </Modal>
  )
}

Settings.propTypes = {
  handleClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
}

export default Settings
